import { num } from "@/lib/format";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Quantità impegnata dai lotti programmati / in taglio, non ancora scalata
export const ReservedInfo = ({ m }) => {
  if (!(m.reserved > 0)) return null;
  const free = (m.quantity || 0) - m.reserved;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="mt-1 block w-full text-[11px] text-amber-400 underline decoration-dotted underline-offset-2" data-testid={`mat-reserved-${m.id}`}>
          Impegnato {num(m.reserved)} {m.unit} · <span className={free < 0 ? "text-rose-400" : "text-emerald-400"} data-testid={`mat-free-${m.id}`}>libero {num(free)} {m.unit}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 text-sm" data-testid={`mat-reserved-pop-${m.id}`}>
        <p className="mb-2 font-medium">Impegnato dai lotti non ancora scaricati</p>
        <ul className="space-y-1">
          {(m.reserved_lots || []).map((l, i) => (
            <li key={i} className="flex justify-between gap-3 text-xs">
              <span>{l.label} <span className="text-muted-foreground">({l.phase})</span></span>
              <b>{num(l.quantity)} {m.unit}</b>
            </li>
          ))}
        </ul>
        {Object.keys(m.reserved_len || {}).length > 0 && (
          <p className="mt-2 text-xs text-muted-foreground">Per lunghezza: {Object.entries(m.reserved_len).map(([k, q]) => `${k} cm × ${num(q)}`).join(" · ")}</p>
        )}
      </PopoverContent>
    </Popover>
  );
};
